/**
 * `SampleChip` — ported from `Foyer_Dashboard_CURRENT.jsx` line 248.
 *
 * Phase 1 difference: the original reads from `SampleTrafficCtx`. The
 * dashboard's per-site sample state lives in `SampleTrafficProvider`
 * (`src/app/providers.tsx`); this atom is a pure visual chip that consumers
 * conditionally render. The condition lives at the call site to keep this
 * atom decoupled from app state.
 */

import { useC } from '../../lib/theme.js';

const monoFont = "'JetBrains Mono', monospace";

export function SampleChip(): JSX.Element {
  const C = useC();
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: monoFont,
        fontSize: 8,
        letterSpacing: 1.5,
        fontWeight: 700,
        color: C.skyFg,
        background: C.skyDim,
        border: `1px solid ${C.skyFg}`,
        padding: '1px 5px',
        borderRadius: 2,
        marginLeft: 8,
      }}
    >
      SAMPLE
    </span>
  );
}
